module.exports = __webpack_public_path__ + "assets/img/amplification_1.2aec6407.svg";